import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import qString from "query-string";

const Canonical = props => {
  const trailingSlashRegex = /\/$/;
  const getCanonicalPath = additionPath => {
    if (props.location.pathname.includes("/all")) {
      return `${props.location.pathname}`;
    } else {
      return !!additionPath
        ? `${props.location.pathname}${additionPath}`
        : `${props.location.pathname}`;
    }
  };

  const getCanonicalPathWithPageAsParam = locObject => {
    if (!!locObject.search) {
      let params = qString.parse(locObject.search);
      if (!!params.p && Number(params.p) !== 1) {
        return `${locObject.pathname.replace(trailingSlashRegex, "")}?p=${
          params.p
        }`;
      } else {
        return locObject.pathname.replace(trailingSlashRegex, "");
      }
    } else {
      return locObject.pathname.replace(trailingSlashRegex, "");
    }
  };

  return (
    <React.Fragment>
      {props.match.path.includes("/vendor/:id/case-studies") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/testimonials") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/customer-videos") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.location.pathname === "/vendor-solutions" && (
        <Helmet>
          <link rel="canonical" href={getCanonicalPath(props.appToPathname)} />
        </Helmet>
      )}
      {props.location.pathname === "/press-releases" && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.location.pathname === "/press-releases/all" && (
        <Helmet>
          <link rel="canonical" href={getCanonicalPath(props.appToPathname)} />
        </Helmet>
      )}
      {props.match.path.includes("/software/:domain") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.match.path.includes("/services/:domain") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/reviews") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
      {props.match.path.includes("/customers-success-reports") && (
        <Helmet>
          <link
            rel="canonical"
            href={
              !!props?.location?.key &&
              getCanonicalPathWithPageAsParam(props.location)
            }
          />
        </Helmet>
      )}
      {props.match.path.includes("/vendors") && (
        <Helmet>
          <link
            rel="canonical"
            href={getCanonicalPathWithPageAsParam(props.location)}
          />
        </Helmet>
      )}
    </React.Fragment>
  );
};

export default withRouter(Canonical);
